// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bYOf-","text_wrapper":"styles_text_wrapper__evez1","description":"styles_description__mBTQy","actions":"styles_actions__QbGfE"};